var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowedUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10017_31509)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10017_31509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7392 3.32228L6.37497 13.6858C6.30529 13.7557 6.22248 13.8112 6.13129 13.8491C6.0401 13.887 5.94233 13.9065 5.84359 13.9065C5.74485 13.9065 5.64708 13.887 5.5559 13.8491C5.46471 13.8112 5.3819 13.7557 5.31222 13.6858L1.30422 9.67403C1.23454 9.60407 1.15173 9.54856 1.06054 9.51069C0.969353 9.47281 0.871584 9.45331 0.772844 9.45331C0.674104 9.45331 0.576335 9.47281 0.485148 9.51069C0.393961 9.54856 0.311151 9.60407 0.241469 9.67403C0.171511 9.74371 0.116002 9.82652 0.0781257 9.91771C0.0402494 10.0089 0.020752 10.1067 0.020752 10.2054C0.020752 10.3041 0.0402494 10.4019 0.0781257 10.4931C0.116002 10.5843 0.171511 10.6671 0.241469 10.7368L4.25097 14.7455C4.67393 15.1677 5.24712 15.4048 5.84472 15.4048C6.44232 15.4048 7.01551 15.1677 7.43847 14.7455L17.802 4.38428C17.8718 4.31461 17.9272 4.23185 17.965 4.14073C18.0028 4.04961 18.0223 3.95193 18.0223 3.85328C18.0223 3.75463 18.0028 3.65695 17.965 3.56583C17.9272 3.47471 17.8718 3.39195 17.802 3.32228C17.7323 3.25232 17.6495 3.19681 17.5583 3.15894C17.4671 3.12106 17.3693 3.10156 17.2706 3.10156C17.1719 3.10156 17.0741 3.12106 16.9829 3.15894C16.8917 3.19681 16.8089 3.25232 16.7392 3.32228Z",
    fill: "#111111"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10017_31509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10017_31509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowedUser);
export default __webpack_public_path__ + "static/media/followed_user.af1302a167d2955479481c2d45fa4506.svg";
export { ForwardRef as ReactComponent };